<template>
  <div>
    <nav class="nav nav-pills">
      <a
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ 'nav-link': true, 'active': tab.active, 'disabled': tab.disabled }"
        @click="activateTab(tab, index)"
        href="#"
      >
        {{ tab.title }}
      </a>
    </nav>
    <div :class="{'change-page-animation': changedTab }">
      <slot :activeTab="activeTab"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const activeTab = ref(0);
    const changedTab = ref(false);

    const activateTab = (tab, index) => {
      if (tab.disabled) return;
      activeTab.value = index;
      props.tabs.forEach((tab, i) => {
        tab.active = i === index;
      });
    };

    watch(activeTab, () => {
      changedTab.value = true;
      setTimeout(() => {
        changedTab.value = false;
      }, 1200);
    })

    return {
      activeTab,
      activateTab,
      changedTab,
    };
  },
});
</script>

<style scoped lang="scss">
nav {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 10px;
  gap: 5px;
}

.nav-link {
  color: #4F3C88;
  font-weight: 300;
  &.disabled {
    color: #ccc;
  }
  &.active {
    background-color: #4F3C88;
    color: #fff;
    &:hover {
      background-color: #4F3C88;
    }
  }
  &:hover {
    background-color: #BCA9F5;
  }
}

.fade-in {
  animation: fadeIn 0.5s ease forwards;
}

.fade-out {
  animation: fadeOut 0.5s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.change-page-animation {
  animation: fadeIn 1s ease forwards;
}
</style>
